// removed by extract-text-webpack-plugin
module.exports = {"base":"Navigation_base--YBl3P","arrow":"Navigation_arrow--1AbTj"};


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/AnnouncementsCard/components/Navigation/Navigation.scss
// module id = 2319
// module chunks = 11